import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TRANSLATION_KEYS } from '@core/constants';
import { DiscountModel, PaginationModel } from '@core/models';
import { Api } from '@core/services/api.state';
import { ApiService } from '@core/services/api/api.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  DialogAction,
  DialogCloseResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiscountsService extends Api<DiscountModel> {
  override endpoint: string;

  constructor(
    protected override readonly apiService: ApiService<DiscountModel>,
    private http: HttpClient,
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {
    super(apiService);
    this.endpoint = `${environment.apiUrl}/v1/admin/discounts`;
  }

  public exportDiscounts(params: PaginationModel): Observable<Blob> {
    params.limit = 1000000;
    params.page = 1;
    const endpoint = `${this.endpoint}/export/excel${`?${new URLSearchParams(
      params as any
    ).toString()}`}`;

    return this.http.get(endpoint, {
      responseType: 'blob',
    });
  }

  public removeRuleToDiscount(data: any) {
    return this.dialogService
      .open({
        title: 'Eliminar regla',
        content: '¿Estás seguro de eliminar este regla en este descuento?',
        actions: [
          {
            text: this.translateService.instant(
              TRANSLATION_KEYS.BUTTONS.CANCEL_LABEL
            ),
          },
          { text: 'Confirmar', themeColor: 'primary' },
        ],
        actionsLayout: 'end',
        width: 500,
        height: 248,
        cssClass: 'confirm-dialog',
      })
      .result.pipe(
        switchMap((result) => {
          if (
            !(result instanceof DialogCloseResult) &&
            (result as DialogAction).text === 'Confirmar'
          ) {
            const endpoint = `${this.endpoint}/rules/remove-rule-to-discount`;
            return this.apiService.post(endpoint, JSON.stringify(data));
          }
          return of(null);
        })
      );
  }

  public assignRule(data: Partial<DiscountModel>): Observable<any> {
    const endpoint = `${this.endpoint}/rules/assing-rule-to-discount`;
    return this.http.post(endpoint, data);
  }
  public updateAssignRule(
    data: Partial<DiscountModel>,
    discountId: string
  ): Observable<any> {
    const endpoint = `${this.endpoint}/rules/edit-assigned-rule/${discountId}`;
    return this.http.put(endpoint, data);
  }
}
